export default __webpack_public_path__ + "static/media/Broker-Consultant-Nelspruit-2026.9378a56f.pdf";